module.exports = __webpack_public_path__ + "static/media/Test11.19d84a9a.bmp";